import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

export const getLang = () => {
  const lang = localStorage.getItem('lang');
  return lang ? JSON.parse(lang) : { value: 'es' };
};

@Component({
  selector: 'body[root]',
  template: `<router-outlet />`,
})
export class AppComponent {
  constructor(
    private readonly translate: TranslateService,
    private readonly modal: NgbModal,
    private readonly router: Router
  ) {
    this.translate.setDefaultLang(getLang()?.value);
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => this.modal.dismissAll());

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => (window as unknown as any)?.KTDrawer?.init());
  }
}
